import { useState, useEffect } from "react";
import axios from "axios";
import config from '../config/config';

const useProductData = (categoryName, partNumber, filters, searchInput, itemcode) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const query =
      searchInput == null || searchInput === ''
        ? ''
        : String(searchInput).trim();

    // Globalna podpowiedź (bez kategorii): puste pole = brak danych i API
    const globalTypeaheadOnly =
      !categoryName &&
      (!filters || filters.length === 0) &&
      !itemcode &&
      !partNumber;

    if (globalTypeaheadOnly && !query) {
      setData([]);
      setLoading(false);
      return;
    }

    let cancelled = false;

    setLoading(true);

    const getProductsApi = async () => {
      let searchFilters = [];

      let categoryCode = null;
      if (categoryName) {
        try {
          const groupResponse = await axios.get(`${config.API_BASE_URL}/group/${categoryName}/id`);
          categoryCode = groupResponse.data.groupId;
        } catch (error) {
          console.error('Error fetching category code:', error);
        }
      }

      if (filters) {
        searchFilters = [...filters];
      }

      if (searchInput) {
        searchFilters.push({
          columnName: "Search",
          value: searchInput,
          operator: "contains"
        });
      }

      if (itemcode) {
        searchFilters.push({
          columnName: "ItemCode",
          value: itemcode,
          operator: "eq"
        });
      }

      if (categoryCode && categoryCode !== -1) {
        searchFilters.push({
          columnName: "Group",
          value: categoryCode,
          operator: "eq"
        });
      }

      const response = await axios.post(`${config.API_BASE_URL}/search`, searchFilters);
      return response.data;
    };

    const timeoutId = setTimeout(async () => {
      try {
        const filteredData = await getProductsApi();
        if (!cancelled) {
          setData(filteredData);
        }
      } catch (error) {
        console.error('Error fetching product data:', error);
        if (!cancelled) {
          setData([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }, 500);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [categoryName, partNumber, filters, searchInput, itemcode]);

  return { data, loading };
};

export default useProductData;
